import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("form", {
    class: "calculation-form",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "fields", {}, undefined, true),
    _createVNode(_component_ButtonComponent, {
      mod: "gradient-bg",
      buttonType: "submit",
      disabled: _ctx.getIsDisabledForm
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.getButtonText), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 32))
}